import { anatomy } from '@shared/tokens/anatomy.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
  },
});
